import classNames from "classnames";

import styles from "./Alert.module.css";

type AlertProps = {
    children: React.ReactNode;
    className?: string;
    type?: "error";
};

export function Alert({ children, className, type = "error", ...props }: AlertProps) {
    return (
        <div role="alert" {...props} className={classNames(styles.alert, className)}>
            {children}
        </div>
    );
}
